import React from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";
import { withStyles } from '@material-ui/styles';

import Header from "../Header/Header";

// pages
import DashboardCustomerService from "../../pages/PagesCustomerService/dashboardCustomerService/DashboardCustomerService";
import SidebarCustomerService from "../SidebarCustomerService/SidebarCustomerService";
import Prodotti from "../../pages/Prodotti";
import Fornitori from "../../pages/Fornitori";
import Ordini from "../../pages/Ordini";
import EditOrdine from "../../pages/EditOrdine";
import Preventivi from "../../pages/Preventivi";
import OrdiniFornitori from "../../pages/OrdiniFornitori";
import AddOrdineFornitore from "../../pages/AddOrdineFornitore";
import EditOrdineFornitore from "../../pages/EditOrdineFornitore";
import GiacenzeMagazzino  from "../../pages/GiacenzeMagazzino";
import UserSettings from "../../pages/UserSettings";
import Ddt from "../../pages/Ddt";
import EditDdt from "../../pages/EditDdt";
import AddDdt from "../../pages/AddDdt";

const makeStyles = theme => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: `calc(100vw - 240px)`,
    minHeight: "100vh",
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing(6)}px) `,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  fakeToolbar: {
    ...theme.mixins.toolbar,
  },
});

class LayoutCustomerService extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      menuItems: [], 
      searchParams: '',
    }
  }

  searchGlobal(text) {
      this.setState({ searchParams: text });
      window.sessionStorage.setItem('search_text', text);
  }

  render (){

    // global
    const { classes } = this.props;

    return (
      <div className={classes.root}>
          <>
            <Header customerservice history={this.props.history} onSearch={(s) => this.searchGlobal(s)} />
            <SidebarCustomerService menuItems={this.state.menuItems}/>
            <div
              className={classnames(classes.content, {
                [classes.contentShift]: null,
              })}
            >
              <div className={classes.fakeToolbar} />
            
              <Switch>

                <Route path="/service/dashboard" component={DashboardCustomerService} />

                <Route path="/service/ordini" component={Ordini} />
                <Route path="/service/edit-ordine" component={EditOrdine} />

                <Route path="/service/preventivi" component={Preventivi} />

                <Route path="/service/prodotti" component={Prodotti} />
                <Route path="/service/fornitori" component={Fornitori} />

                <Route path="/service/ordini-fornitori" component={OrdiniFornitori} />
                <Route path="/service/add-ordine-fornitore" component={AddOrdineFornitore} />
                <Route path="/service/edit-ordine-fornitore" component={EditOrdineFornitore} />

                <Route path="/service/giacenze-magazzino" component={GiacenzeMagazzino} />
                <Route path="/service/usersettings" component={UserSettings} />

                <Route path="/service/ddt" component={Ddt} />
                <Route path="/service/edit-ddt" component={EditDdt} />
                <Route path="/service/add-ddt" component={AddDdt} />

                <Route
                  exact
                  path="/service/ui"
                  render={() => <Redirect to="/app/ui/icons" />}
                />
              </Switch>
            </div>
            <div
              className={classnames(classes.contentPhone)}
            >
            </div>
          </>
      </div>
    );
  }
  
}

export default withStyles(makeStyles)(withRouter(LayoutCustomerService));
